export const EMAIL = "mailTo: info@butterfield.com";
export const PHONE = "tel: 1800-678-1147";
export const ERROR_MESSAGE = `We're experiencing some issues on our backend, please standby while our team resolves the issue.`;
export const ERROR_TITLE = "Something went wrong";
